import { h } from 'preact';
import * as BaseComp from 'components/bolt/footer/footer.js';
import { findInVNode } from 'utils/vnode';
import s from 'components/bolt/footer/footer.sss';

export default class Footer extends BaseComp.default {

	constructor(props) {
		super(props);
		this.onKeyDown = this.onKeyDown.bind(this);
	}

	componentDidMount() {
		super.componentDidMount();
		document.addEventListener('keydown', this.onKeyDown);
	}

	componentWillUnmount() {
		super.componentWillUnmount?.();
		document.removeEventListener('keydown', this.onKeyDown);
	}

	onKeyDown(e) {
		if (e.key === 'Escape' && this.state.open) {
			this.closeFooter();
		}
	}

	render(props, state) {
		const base = super.render(props, state);
		const scrollBtn = findInVNode(base, `.${s.scrollTop}`);
		if (scrollBtn) {
			scrollBtn.attributes.style = { display: 'none' };
		}

		return base;
	}
}
